import type {
  CheckboxGroupRef,
  DynamicFieldComponentProps,
  DynamicFieldDataProps,
  MakeRequired,
} from '@myosh/odin-components';
import { CheckboxGroup } from '@myosh/odin-components';
import React from 'react';
import type { Control } from 'react-hook-form';
import type { LookupTypeFieldProps } from '../../../@types/forms';
import useOptionFieldOptions from './use-option-field-options';

interface MultiselectCheckboxResult {
  value: unknown;
  text: string;
}

export interface MultiselectCheckboxProps
  extends
    MakeRequired<DynamicFieldComponentProps<Array<MultiselectCheckboxResult>>, 'name'>,
    DynamicFieldDataProps,
    LookupTypeFieldProps {
  control: Control;
  formId: number;
  multiSelectCheckboxType?: 'buttons' | 'checkboxes';
}

export default function MultiselectCheckbox({
  id,
  name,
  control,
  textField,
  valueField,
  formId,
  lookupType,
  lookupKeyId,
  lookupHierarchyId,
  value,
  multiSelectCheckboxType,
  ...rest
}: MultiselectCheckboxProps) {
  const { scrollerRef, getOptionsData } = useOptionFieldOptions(
    formId,
    control,
    lookupType,
    lookupKeyId,
    lookupHierarchyId
  );

  return (
    <CheckboxGroup
      {...rest}
      ref={scrollerRef as React.Ref<CheckboxGroupRef>}
      id={id}
      textField={textField}
      valueField={valueField}
      value={value}
      data={getOptionsData}
      name={name}
      archivedField="archived"
      showSelectedArchivedOptions={true}
      multiSelectCheckboxType={multiSelectCheckboxType}
    />
  );
}
